import React from "react";
import "../about/about.css";
import BookingComponent from "./BookingComponent";


const BookingForm = () => {
  return (
    <div className="about-container">
      <div className="about-cloud">
        <div className="right-text-wrapper">
          {/* <h1>A</h1>
          <h1>B</h1>
          <h1>O</h1>
          <h1>U</h1>
          <h1>T</h1> */}
        </div>
        {/* <div className="cloud-blob"> */}
        <img
          src="/book-now-img.png"
          alt="Adventure group"
          className="cloud-img-inside"
        />
        {/* </div> */}
      </div>
      <div className="about-text">
        <BookingComponent/>
      </div>
    </div>
  );
};

export default BookingForm;
